export const SKILL_MATRIX_SECTIONS = [
    { slug: "operazioni-standard", title: "Operazioni standard" },
    { slug: "abilitazioni", title: "Abilitazioni" },
    { slug: "requisiti-sicurezza", title: "Requisiti sicurezza" },
    { slug: "operatori-abilitati", title: "Operatori abilitati" },
    { slug: "controlli-manutenzioni", title: "Controlli e manutenzioni" },
    { slug: "storico-centri", title: "Storico centri" },
];

export const COMPETENCE_SECTIONS = [
    { slug: "valutazioni", title: "Valutazioni", group: "Persone", routeName: "hr-competenze-valutazioni" },
    { slug: "formazione-fasi", title: "Formazione per fase", group: "Persone", routeName: "hr-competenze-formazione" },
    ...SKILL_MATRIX_SECTIONS.map(section => ({ ...section, group: section.slug === "storico-centri" ? "Archivio" : "Centri e operazioni", routeName: `hr-matrix-${section.slug}` })),
];

export function skillMatrixRoute(index, query = {}) {
    return { name: `hr-matrix-${SKILL_MATRIX_SECTIONS[index].slug}`, query };
}
